module.exports = __webpack_public_path__ + "img/zz_hover.c0b008dd.png";